<template>
    <div>
        <!-- Lives inside top nav -->
        <b-navbar-nav
            v-if="isNavHorizontal"
            class="nav-utility-horizontal"
            :class="[isEnhancedLayout ? 'enhanced-layout' : 'classic-layout']"
        >
            <nav-utility-business
                :class="{ 'd-none d-xxl-block': isEnhancedLayout }"
                :setting="$root.setting"
            />
            <nav-utility-global-search v-if="isEnhancedLayout" />
            <nav-utility-quick-add
                :class="{ 'd-none d-xxl-block': isEnhancedLayout }"
            />
            <nav-utility-log
                :class="{ 'd-none d-xxl-block': isEnhancedLayout }"
            />
            <nav-utility-notifications
                :class="{ 'd-none d-xxl-block': isEnhancedLayout }"
                @toggle="toggleAppNotifications"
            />
            <nav-utility-tasks
                :class="{ 'd-none d-xxl-block': isEnhancedLayout }"
                :showNewTaskModal="showNewTaskModal"
                :isNotificationEnabled="true"
            />
            <nav-utility-help
                :class="{ 'd-none d-xxl-block': isEnhancedLayout }"
                :hasUnreadNews="hasUnreadNews"
                :helpIconKey="helpIconKey"
                @open-news="toggleWhatsNew"
                @open-helpdesk="contactSupport"
                @open-e-learning="openWorkramp"
            />
            <nav-utility-profile
                :class="{ 'd-none d-xxl-block': isEnhancedLayout }"
                :current-actor="$root.currentActor"
            />
        </b-navbar-nav>

        <!-- Lives inside left nav-->
        <ul v-if="isInsideLeftNav" class="nav-utility-vertical">
            <nav-utility-business :setting="$root.setting" />
            <nav-utility-quick-add
                :is-nav-horizontal="isNavHorizontal"
                :show-option-menu="currentShortcut === 'quick-add'"
                @toggle-visibility="updateCurrentShortcut('quick-add')"
            />
            <nav-utility-log
                :is-nav-horizontal="isNavHorizontal"
                :show-option-menu="currentShortcut === 'recent'"
                @toggle-visibility="updateCurrentShortcut('recent')"
            />
            <nav-utility-notifications
                :is-nav-horizontal="isNavHorizontal"
                @toggle-drawer="toggleAppNotifications"
            />
            <nav-utility-tasks
                :show-new-task-modal="showNewTaskModal"
                :isNotificationEnabled="true"
                :is-nav-horizontal="isNavHorizontal"
                :show-option-menu="currentShortcut === 'task'"
                @toggle-visibility="updateCurrentShortcut('task')"
            />
            <nav-utility-help
                :is-nav-horizontal="isNavHorizontal"
                :show-option-menu="currentShortcut === 'help'"
                :has-unread-news="hasUnreadNews"
                :help-icon-key="helpIconKey"
                @toggle-visibility="updateCurrentShortcut('help')"
                @open-news="toggleWhatsNew"
                @open-helpdesk="contactSupport"
                @open-e-learning="openWorkramp"
            />
        </ul>

        <modal-new-task ref="newTaskWindow" />
    </div>
</template>

<script>
import NavUtilityProfile from "@/module/layout/nav-utility-profile.vue";
import NavUtilityQuickAdd from "@/module/layout/nav-utility-shortcut.vue";
import NavUtilityLog from "@/module/layout/nav-utility-log.vue";
import NavUtilityBusiness from "@/module/layout/nav-utility-business.vue";
import NavUtilityNotifications from "@/module/layout/nav-utility-notifications.vue";
import NavUtilityTasks from "@/module/layout/nav-utility-tasks.vue";
import ModalNewTask from "@/components/tasks/task-update-modal";
import NavUtilityHelp from "@/module/layout/nav-utility-help.vue";
import NavUtilityGlobalSearch from "@/module/layout/nav-utility-global-search.vue";

export default {
    name: "NavUtility",
    components: {
        NavUtilityGlobalSearch,
        NavUtilityProfile,
        NavUtilityQuickAdd,
        NavUtilityLog,
        NavUtilityBusiness,
        NavUtilityNotifications,
        NavUtilityTasks,
        NavUtilityHelp,
        ModalNewTask
    },
    props: {
        isNavHorizontal: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            currentShortcut: null
        };
    },
    computed: {
        hasUnreadNews() {
            return this.$store.state.hasUnreadNews;
        },
        helpIconKey() {
            return this.$store.state.helpIconKey;
        },
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        },
        isInsideLeftNav() {
            return this.isEnhancedLayout && !this.isNavHorizontal;
        }
    },
    methods: {
        showNewTaskModal() {
            this._toggleEnhancedLayoutMobileSideMenu();
            this.$refs.newTaskWindow.open();
        },
        toggleAppNotifications() {
            if (!this.isNavHorizontal) {
                this.updateCurrentShortcut("notification");
            }

            this.$store.commit("toggleAppNotification");
        },
        toggleWhatsNew() {
            this.$store.commit("toggleWhatsNew");
        },
        contactSupport() {
            window.Intercom("show");
        },
        updateCurrentShortcut(name) {
            this.currentShortcut = this.currentShortcut === name ? null : name;
        },
        openWorkramp() {
            const SUCCESS_MESSAGE = "Redirecting to Workramp.";
            const ERR_MESSAGE = "Unable to connect Workramp.";
            return this.$http
                .get(process.env.BARRAMUNDI + "actor/workramp")
                .then(response => {
                    if (response?.data?.response?.code == 200) {
                        let data = response.data.response.resource;
                        // open new window
                        this._message(SUCCESS_MESSAGE, "success");
                        window.open(data, "_blank");
                    } else {
                        this._message(ERR_MESSAGE, "danger");
                    }
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.nav-utility-horizontal {
    display: flex;
    flex-wrap: wrap;

    &.classic-layout {
        flex-direction: column;

        ::v-deep li > a.nav-link,
        ::v-deep li#nav-item-business > a.nav-link {
            color: #fff !important;
        }

        ::v-deep li > a.nav-link > .fas {
            color: #fff;
            margin-right: 7px;
        }
    }

    &.enhanced-layout {
        flex-direction: row;
        align-items: center;
        padding-right: 24px;

        ::v-deep li > a.nav-link,
        ::v-deep li#nav-item-business > a.nav-link {
            color: #000;
        }
    }
}

.nav-utility-vertical {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    list-style: none;

    ::v-deep li#nav-item-business > a.nav-link {
        padding-left: 12px;
        padding-right: 12px;
    }
}

@media screen and (min-width: 501px) {
    .d-xs-block {
        display: block !important;
    }
}

@media screen and (min-width: 992px) {
    .nav-utility-horizontal {
        &.classic-layout {
            flex-direction: row;
            align-items: center;
        }

        &.classic-layout,
        &.enhanced-layout {
            ::v-deep li > a.nav-link,
            ::v-deep li#nav-item-business > a.nav-link {
                padding-left: 10px;
                padding-right: 10px;

                & > .fas {
                    margin-right: unset;
                }
            }
        }
    }
}

@media screen and (min-width: 1400px) {
    .nav-utility-horizontal {
        &.enhanced-layout {
            padding-right: 10px;
        }
    }

    .nav-utility-vertical {
        display: none;
    }

    .d-xxl-block {
        display: block !important;
    }
}
</style>
